import { render, staticRenderFns } from "./mobile_container_depot.vue?vue&type=template&id=0672de5e&scoped=true&"
import script from "./mobile_container_depot.vue?vue&type=script&lang=js&"
export * from "./mobile_container_depot.vue?vue&type=script&lang=js&"
import style0 from "./mobile_container_depot.vue?vue&type=style&index=0&id=0672de5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672de5e",
  null
  
)

export default component.exports